"use strict";
// This file is generated by import-svg script
Object.defineProperty(exports, "__esModule", { value: true });
exports.defNames = void 0;
exports.defNames = "clipPath, radialGradient, linearGradient";
